import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from "./TableCaption.styled";
export const TableCaption = ({ children, ...props }) => children ? (_jsx(Styled.Caption, { "data-testid": "TableCaption", ...props, children: children })) : null;
